// extracted by mini-css-extract-plugin
module.exports = {"lenkepanel":"Omradekort_lenkepanel__1rlPi","titleShort":"Omradekort_titleShort__2nrxY","titleLong":"Omradekort_titleLong__oh9rl"};